import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlatformService {

  channels: Array<{ platform_id: string; platform_name: string; shop_ref: string; member_id: string; logo_url: string; color: string, platform: string, platform_group_id: string, is_branch?: boolean, branch_number?: string }> = []
  channelsAll: Array<{ platform_id: string; platform_name: string; shop_ref: string; member_id: string; logo_url: string; color: string, platform: string, platform_group_id: string, is_branch?: boolean, branch_number?: string }> = []
  endpoint = environment.endpoint;

  constructor(
    private http: HttpClient
  ) { }


  getAllPlatform(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/platform`, { params: filters }));
  }

  getMyPlatforms() {
    return firstValueFrom(this.http.get(`${this.endpoint}/user-platform/me/platforms`));
  }

  updatePlatform(id: string, body: any) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/platform/${id}`, body));
  }

}
